import { render, staticRenderFns } from "./Flights.vue?vue&type=template&id=f274e968&scoped=true"
import script from "./Flights.vue?vue&type=script&lang=js"
export * from "./Flights.vue?vue&type=script&lang=js"
import style0 from "./Flights.vue?vue&type=style&index=0&id=f274e968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f274e968",
  null
  
)

export default component.exports